import { render, staticRenderFns } from "./OtherInformation.vue?vue&type=template&id=3a08d423"
import script from "./OtherInformation.vue?vue&type=script&lang=js"
export * from "./OtherInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports